import React from "react";

export default class Image extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { error: false };
    this.onError = this.onError.bind(this);
  }

  onError() {
    this.setState({ error: true }); // eslint-disable-line react/no-set-state
  }

  render() {
    var { children, className, src } = this.props;
    var { error } = this.state;
    if (error) {
      return children;
    } else {
      return <img className={className} onError={this.onError} src={src} />;
    }
  }
}
